var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"language-toggle-button",on:{"click":_vm.toggleLanguage}},[_vm._v(" "+_vm._s(_vm.$i18n.locale === 'nl' ? 'EN' : 'NL')+" ")]),_c('Home'),_c('Menu'),_c('Practical'),_c('Book'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }